import React from "react";
import { ArrowUpRight } from "lucide-react";
import { BrowserFrame } from "./Frames";
import { PROJECTS } from "../mock";
import { Script } from "./Script";

export default function Portfolio() {
  return (
    <section id="portfolio" className="bg-[#0e0e0d] py-24 md:py-32" data-testid="portfolio-section">
      <div className="container-x">
        <div className="reveal max-w-3xl">
          <p className="eyebrow text-[#8b8b80]">Portfolio</p>
          <h2 className="display text-white text-4xl sm:text-5xl lg:text-6xl mt-4">
            Weby, které už běží{" "}
            <Script color="#d8ff00" className="text-[#d8ff00] text-5xl sm:text-6xl lg:text-7xl mx-2">
              naživo.
            </Script>
          </h2>
          <p className="text-[#a5a59d] mt-10 max-w-xl">
            Každý projekt si můžete otevřít a proklikat. Nic naaranžovaného — reálné weby reálných klientů.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-6 gap-5">
          {PROJECTS.map((p) => (
            <a
              key={p.id}
              href={p.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`project-card-${p.id}`}
              className={`reveal tile-dark p-5 group ${p.span || "md:col-span-2"}`}
            >
              <BrowserFrame
                dark
                media={p.media}
                host={p.host}
                mediaClass="aspect-[16/9] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="flex items-start justify-between gap-4 mt-6 px-1 pb-1">
                <div>
                  <p className="text-xs text-[#d8ff00]">
                    {p.category} · {p.year}
                  </p>
                  <h3 className="display text-white text-xl md:text-2xl mt-1.5">{p.name}</h3>
                  <p className="text-sm text-[#a5a59d] mt-2 max-w-sm">{p.desc}</p>
                </div>
                <span className="grid place-items-center w-11 h-11 rounded-full border border-white/15 text-white shrink-0 transition-all duration-300 group-hover:bg-[#d8ff00] group-hover:text-[#0e0e0d] group-hover:border-[#d8ff00]">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
